(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shelly-guide-hub"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('shelly-guide-hub')) return;

    var norm = function (s) {
      return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
    };
    var X_ICON = '<svg class="sgh-icon" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12"/><path d="M18 6 6 18"/></svg>';
    var all = function (root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    if (!document.querySelector('link[data-shelly-fonts]')) {
      var f = document.createElement('link');
      f.rel = 'stylesheet';
      f.href = 'https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600;700&family=Roboto:wght@400;500&display=swap';
      f.setAttribute('data-shelly-fonts', '');
      document.head.appendChild(f);
    }

    class ShellyGuideHub extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var d = this.dataset;
        this.per = parseInt(d.perPage, 10) || 12;
        this.nlAfter = parseInt(d.nlAfter, 10) || 0;
        this.design = d.design === 'true';
        this.grid = this.querySelector('[data-hub-grid]');
        this.news = this.querySelector('[data-hub-newsletter]');
        this.search = this.querySelector('[data-hub-search]');
        this.clearBtn = this.querySelector('[data-hub-clear]');
        this.sortSels = all(this, '[data-hub-sort]');
        this.sortName = this.querySelector('[data-hub-sort-name]');
        this.statusEl = this.querySelector('[data-hub-status]');
        this.moreBtn = this.querySelector('[data-hub-more]');
        this.emptyEl = this.querySelector('[data-hub-empty]');
        this.tabsEl = this.querySelector('[data-hub-tabs]');
        this.chips = all(this, '[data-hub-tabs] [data-cat]');
        this.opts = all(this, '[data-cat-opt]');
        this.topicGroup = this.querySelector('[data-hub-topic-group]');
        this.topicList = this.querySelector('[data-hub-topic-list]');
        this.pills = this.querySelector('[data-hub-pills]');
        this.pillList = this.querySelector('[data-hub-pill-list]');
        this.activeEl = this.querySelector('[data-hub-active]');
        this.panel = this.querySelector('[data-hub-panel]');
        this.panelBox = this.querySelector('[data-hub-panel-box]');
        this.openBtn = this.querySelector('[data-hub-panel-open]');
        this.filtersText = this.querySelector('[data-hub-filters-text]');
        this.applyBtn = this.querySelector('[data-hub-apply]');
        this.clearAllBtn = this.querySelector('[data-hub-clear-all]');
        this.topicEls = {};
        var feature = this.querySelector('[data-hub-feature]');
        this.featureKey = feature ? feature.dataset.key : '';
        this.inAll = {};
        this.catNames = {};
        this.chips.forEach(function (c) {
          this.inAll[c.dataset.cat] = c.dataset.inAll !== 'false';
          var n = c.querySelector('.sgh-tab__name');
          this.catNames[c.dataset.cat] = n ? n.textContent.trim() : c.textContent.trim();
        }, this);

        var self = this, reg = [];
        try { reg = JSON.parse(d.topicList || '[]'); } catch (e) {}
        this.reg = {};
        this.regOrder = [];
        this.labels = {};
        this.subs = {};
        this.known = {};
        var byLabel = {};
        reg.forEach(function (t) {
          if (!t || !t.k || self.reg[t.k]) return;
          self.reg[t.k] = t.l || t.k;
          self.regOrder.push(t.k);
          byLabel[norm(t.l)] = t.k;
        });
        var hasReg = this.regOrder.length > 0;
        var slug = function (s) { return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); };
        var rawTopics = function (raw) {
          var out = [];
          raw.split('|').forEach(function (r) {
            r = r.trim();
            if (!r) return;
            var k = slug(r);
            if (hasReg) k = self.reg[k] ? k : byLabel[norm(r)];
            else if (k && !self.labels[k]) self.labels[k] = r;
            if (k && out.indexOf(k) === -1) out.push(k);
          });
          return out;
        };

        var seen = {}, seenCat = {};
        this.items = [];
        Array.prototype.forEach.call(this.grid.querySelectorAll('[data-hub-item]'), function (el, i) {
          var t = el.querySelector('.sgh-card__title');
          var key = el.dataset.key || ('#' + i);
          var ck = el.dataset.cat + '|' + key;
          var topics = el.dataset.topics ? el.dataset.topics.split(' ').filter(Boolean) : rawTopics(el.dataset.topicsRaw || '');
          var sub = el.dataset.sub || '';
          if (sub) self.subs[sub] = el.dataset.subLabel || sub;
          topics.forEach(function (k) { self.known[k] = true; });
          var kick = el.querySelector('[data-hub-kicker]');
          if (kick && hasReg) {
            var kl = topics.length ? self.reg[topics[0]] : el.dataset.subLabel;
            if (kl) kick.textContent = kl; else kick.remove();
          }
          var first = seenCat[ck];
          if (first) {
            if (sub && !first.sub) first.sub = sub;
            topics.forEach(function (k) { if (first.topics.indexOf(k) === -1) first.topics.push(k); });
            el.remove();
            return;
          }
          var it = {
            el: el, i: self.items.length, cat: el.dataset.cat, key: key, dup: !!seen[key],
            topics: topics, sub: sub,
            date: parseInt(el.dataset.date, 10) || 0,
            title: t ? t.textContent.trim() : '',
            text: norm(el.textContent)
          };
          seen[key] = true;
          seenCat[ck] = it;
          self.items.push(it);
        });

        var saved = null;
        try { saved = localStorage.getItem('sgh-view'); } catch (e) {}
        this.state = { cat: 'all', topics: [], sub: '', q: '', sort: d.sort || 'featured', view: saved || d.view || 'grid', shown: this.per };
        this.readUrl();
        this.bind();
        this.formatDates();
        this.setView(this.state.view, true);
        this.render(false);
        this.initSticky();
        var cols = this.columns(), rt;
        this._onResize = function () {
          clearTimeout(rt);
          rt = setTimeout(function () {
            var c = self.columns();
            if (c !== cols) { cols = c; self.placeNews(); }
            self.fadeTabs();
            if (innerWidth >= 750) self.closePanel(false);
          }, 150);
        };
        addEventListener('resize', this._onResize);
      }

      disconnectedCallback() {
        if (this._onScroll) removeEventListener('scroll', this._onScroll);
        if (this._onResize) removeEventListener('resize', this._onResize);
        if (this._onKey) document.removeEventListener('keydown', this._onKey);
        if (this._sticky) this._sticky.remove();
        document.documentElement.classList.remove('sgh-lock');
      }

      readUrl() {
        if (this.dataset.updateUrl !== 'true') return;
        var self = this, p = new URLSearchParams(location.search);
        var h = p.get('hub');
        if (h) {
          var chip = this.chips.filter(function (c) { return c.dataset.handle === h; })[0];
          if (chip) this.state.cat = chip.dataset.cat;
        }
        (p.get('topic') || '').split(',').forEach(function (k) {
          k = k.trim();
          if (!k) return;
          if (self.subs[k]) self.state.sub = k;
          else if ((self.reg[k] || self.labels[k] || self.known[k]) && self.state.topics.indexOf(k) === -1) self.state.topics.push(k);
        });
        this.state.q = p.get('q') || '';
        if (this.search && this.state.q) this.search.value = this.state.q;
      }

      writeUrl() {
        if (this.dataset.updateUrl !== 'true' || this.design || !history.replaceState) return;
        var st = this.state, u = new URL(location.href);
        var chip = this.chips.filter(function (c) { return c.dataset.cat === st.cat; })[0];
        var set = function (k, v) { if (v) u.searchParams.set(k, v); else u.searchParams.delete(k); };
        set('hub', st.cat === 'all' || !chip ? '' : chip.dataset.handle);
        set('topic', (st.sub ? [st.sub] : []).concat(st.topics).join(','));
        set('q', st.q);
        history.replaceState(history.state, '', u.pathname + u.search.replace(/%2C/gi, ',') + u.hash);
      }

      bind() {
        var self = this;
        this.chips.forEach(function (c) {
          c.addEventListener('click', function () { self.setCat(c.dataset.cat); });
        });
        this.opts.forEach(function (o) {
          var input = o.querySelector('input');
          if (input) input.addEventListener('change', function () { if (input.checked) self.setCat(input.value); });
        });
        if (this.search) {
          var timer;
          this.search.addEventListener('input', function () {
            clearTimeout(timer);
            timer = setTimeout(function () {
              self.state.q = self.search.value;
              self.state.shown = self.per;
              self.render(true);
            }, 140);
          });
          this.search.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') { self.search.value = ''; self.state.q = ''; self.render(true); }
            if (e.key === 'Enter') e.preventDefault();
          });
        }
        this._onKey = function (e) {
          if (e.key === 'Escape' && self.panel && self.panel.classList.contains('is-open')) { self.closePanel(false); return; }
          var tag = (e.target && e.target.tagName) || '';
          if (self.search && e.key === '/' && !/INPUT|TEXTAREA|SELECT/.test(tag) && !e.target.isContentEditable) {
            var r = self.getBoundingClientRect();
            if (r.bottom > 0 && r.top < innerHeight) { e.preventDefault(); self.search.focus(); }
          }
        };
        document.addEventListener('keydown', this._onKey);
        if (this.clearBtn) this.clearBtn.addEventListener('click', function () {
          self.search.value = ''; self.state.q = ''; self.render(true); self.search.focus();
        });
        this.sortSels.forEach(function (sel) {
          sel.addEventListener('change', function () { self.state.sort = sel.value; self.render(true); });
        });
        all(this, '[data-hub-view]').forEach(function (b) {
          b.addEventListener('click', function () { self.setView(b.dataset.hubView); self.render(false); });
        });
        this.moreBtn.addEventListener('click', function () {
          self.state.shown += self.per; self.render(true, true);
        });
        this.querySelector('[data-hub-reset]').addEventListener('click', function () { self.reset(); });
        if (this.topicList) this.topicList.addEventListener('change', function (e) {
          var i = e.target.closest('input[data-topic]');
          if (i) self.toggleTopic(i.dataset.topic, i.checked);
        });
        if (this.pillList) this.pillList.addEventListener('click', function (e) {
          var b = e.target.closest('[data-topic]');
          if (b) self.toggleTopic(b.dataset.topic, b.getAttribute('aria-pressed') !== 'true');
        });
        if (this.activeEl) this.activeEl.addEventListener('click', function (e) {
          var b = e.target.closest('[data-remove]');
          if (!b) return;
          if (b.dataset.remove === '#cat') self.setCat('all');
          else self.toggleTopic(b.dataset.remove, false);
        });
        if (this.clearAllBtn) this.clearAllBtn.addEventListener('click', function () { self.clearFilters(true); });
        all(this, '[data-hub-clear-topics]').forEach(function (b) {
          b.addEventListener('click', function () { self.clearFilters(false); });
        });
        if (this.openBtn) this.openBtn.addEventListener('click', function () { self.openPanel(); });
        all(this, '[data-hub-panel-close]').forEach(function (b) {
          b.addEventListener('click', function () { self.closePanel(false); });
        });
        if (this.applyBtn) this.applyBtn.addEventListener('click', function () { self.closePanel(true); });
        if (this.tabsEl) this.tabsEl.addEventListener('scroll', function () { self.fadeTabs(); }, { passive: true });
        if (this.design) {
          document.addEventListener('shopify:block:select', function (e) {
            if (!e.detail || e.detail.sectionId !== self.dataset.section) return;
            var c = self.chips.filter(function (x) { return (x.dataset.blocks || '').split(' ').indexOf(e.detail.blockId) > -1; })[0];
            if (c) { self.state.cat = c.dataset.cat; self.state.topics = []; self.state.sub = ''; self.render(false); }
          });
        }
      }

      setCat(cat) {
        var st = this.state;
        if (cat !== st.cat) st.sub = '';
        st.cat = cat;
        st.shown = this.per;
        this.render(true);
        var c = this.chips.filter(function (x) { return x.dataset.cat === cat; })[0], t = this.tabsEl;
        if (c && t && t.scrollWidth > t.clientWidth) {
          var l = c.offsetLeft - t.offsetLeft, r = l + c.offsetWidth;
          if (l < t.scrollLeft || r > t.scrollLeft + t.clientWidth) t.scrollTo({ left: Math.max(0, l - 24), behavior: 'smooth' });
        }
      }

      toggleTopic(k, on) {
        var st = this.state;
        if (this.subs[k]) st.sub = on ? k : '';
        else {
          var i = st.topics.indexOf(k);
          if (on && i === -1) st.topics.push(k);
          if (!on && i > -1) st.topics.splice(i, 1);
        }
        st.shown = this.per;
        this.render(true);
      }

      clearFilters(withCat) {
        this.state.topics = [];
        this.state.sub = '';
        if (withCat) this.state.cat = 'all';
        this.state.shown = this.per;
        this.render(true);
      }

      reset() {
        this.state.cat = 'all'; this.state.topics = []; this.state.sub = ''; this.state.q = ''; this.state.shown = this.per;
        if (this.search) this.search.value = '';
        this.render(true);
      }

      openPanel() {
        if (!this.panel) return;
        this._lastFocus = document.activeElement;
        this.panel.classList.add('is-open');
        this.panelBox.setAttribute('role', 'dialog');
        this.panelBox.setAttribute('aria-modal', 'true');
        document.documentElement.classList.add('sgh-lock');
        if (this.openBtn) this.openBtn.setAttribute('aria-expanded', 'true');
        var box = this.panelBox;
        setTimeout(function () { box.focus({ preventScroll: true }); }, 60);
      }

      closePanel(toResults) {
        if (!this.panel || !this.panel.classList.contains('is-open')) return;
        this.panel.classList.remove('is-open');
        this.panelBox.removeAttribute('role');
        this.panelBox.removeAttribute('aria-modal');
        document.documentElement.classList.remove('sgh-lock');
        if (this.openBtn) this.openBtn.setAttribute('aria-expanded', 'false');
        if (this._lastFocus && this._lastFocus.focus) this._lastFocus.focus({ preventScroll: true });
        if (toResults) {
          var res = this.querySelector('.sgh-result');
          var top = res ? res.getBoundingClientRect().top : 0;
          if (res && (top < 0 || top > innerHeight * 0.5)) scrollTo({ top: scrollY + top - 100, behavior: 'smooth' });
        }
      }

      fadeTabs() {
        var t = this.tabsEl;
        if (!t) return;
        t.classList.toggle('is-more', t.scrollWidth - t.clientWidth - t.scrollLeft > 4);
      }

      setView(v, silent) {
        if (v !== 'grid' && v !== 'rows') v = 'grid';
        this.state.view = v;
        this.grid.classList.toggle('sgh-grid--grid', v === 'grid');
        this.grid.classList.toggle('sgh-grid--rows', v === 'rows');
        all(this, '[data-hub-view]').forEach(function (b) {
          b.setAttribute('aria-pressed', b.dataset.hubView === v ? 'true' : 'false');
        });
        if (!silent) { try { localStorage.setItem('sgh-view', v); } catch (e) {} }
      }

      fits(it, cat, topics, sub, words) {
        if (cat === 'all') {
          if (!this.inAll[it.cat]) return false;
          if (it.dup && this.dataset.dedupe === 'true') return false;
          if (this.featureKey && it.key === this.featureKey) return false;
        } else if (it.cat !== cat) return false;
        if (sub && it.sub !== sub) return false;
        if (topics.length) {
          var hit = false;
          for (var j = 0; j < topics.length; j++) if (it.topics.indexOf(topics[j]) > -1) { hit = true; break; }
          if (!hit) return false;
        }
        for (var i = 0; i < words.length; i++) if (it.text.indexOf(words[i]) === -1) return false;
        return true;
      }

      label(k) {
        return this.subs[k] || this.reg[k] || this.labels[k] || k;
      }

      render(animate, appending) {
        var self = this, st = this.state;
        var words = norm(st.q).split(' ').filter(Boolean);
        if (this.clearBtn) this.clearBtn.hidden = !st.q;
        if (st.cat === 'all') st.sub = '';

        var map = {}, seenOrder = [], subOrder = [];
        var add = function (k, sub) {
          if (!map[k]) {
            map[k] = { label: self.label(k), n: 0, sub: sub };
            (sub ? subOrder : seenOrder).push(k);
          }
          map[k].n++;
        };
        this.items.forEach(function (it) {
          if (self.fits(it, st.cat, [], st.sub, words)) it.topics.forEach(function (k) { add(k, false); });
          if (st.cat !== 'all' && it.sub && self.fits(it, st.cat, st.topics, '', words)) add(it.sub, true);
        });
        if (st.sub && !map[st.sub]) { map[st.sub] = { label: this.label(st.sub), n: 0, sub: true }; subOrder.push(st.sub); }
        st.topics.forEach(function (k) {
          if (!map[k]) { map[k] = { label: self.label(k), n: 0, sub: false }; seenOrder.push(k); }
        });
        var topicOrder = this.regOrder.length
          ? this.regOrder.filter(function (k) { return map[k]; }).concat(st.topics.filter(function (k) { return !self.reg[k]; }))
          : seenOrder;
        this.renderTopics(map, subOrder, topicOrder);

        var list = this.items.filter(function (it) { return self.fits(it, st.cat, st.topics, st.sub, words); });
        var lang = document.documentElement.lang || undefined;
        if (st.sort === 'featured' && st.cat === 'all' && this.dataset.mix === 'true') list = this.interleave(list);
        else if (st.sort === 'newest') list.sort(function (a, b) { return (b.date - a.date) || (a.i - b.i); });
        else if (st.sort === 'az') list.sort(function (a, b) { return a.title.localeCompare(b.title, lang); });

        var prevShown = appending ? st.shown - this.per : 0;
        var cols = this.columns(), n = Math.min(st.shown, list.length);
        if (cols > 1 && n < list.length) {
          var feat = this.dataset.highlight === 'true' && !words.length, slots = 0;
          var width = function (it, k) { return it.el.classList.contains('sgh-card--spotlight') || (k === 0 && feat) ? 2 : 1; };
          for (var k = 0; k < n; k++) slots += width(list[k], k);
          while (n < list.length && slots % cols) { slots += width(list[n], n); n++; }
          st.shown = n;
        }
        var visible = list.slice(0, st.shown);
        this.items.forEach(function (it) { it.el.hidden = true; it.el.classList.remove('is-featured', 'is-entering'); });
        list.forEach(function (it) { self.grid.appendChild(it.el); });
        visible.forEach(function (it, k) {
          it.el.hidden = false;
          if (animate && k >= prevShown) {
            it.el.style.setProperty('--sgh-delay', Math.min(k - prevShown, 11) * 35 + 'ms');
            void it.el.offsetWidth;
            it.el.classList.add('is-entering');
          }
        });
        if (this.dataset.highlight === 'true' && st.view === 'grid' && !words.length && visible[0] && !visible[0].el.classList.contains('sgh-card--spotlight')) {
          visible[0].el.classList.add('is-featured');
        }

        this._visible = visible;
        this.placeNews();

        var counts = {}, bases = {};
        var cats = ['all'].concat(this.chips.map(function (c) { return c.dataset.cat; }).filter(function (c) { return c !== 'all'; }));
        cats.forEach(function (cat) {
          var cn = 0, base = 0, sub = cat === st.cat ? st.sub : '';
          self.items.forEach(function (it) {
            if (!self.fits(it, cat, [], '', words)) return;
            base++;
            if (self.fits(it, cat, st.topics, sub, words)) cn++;
          });
          counts[cat] = cn;
          bases[cat] = base;
        });
        var paint = function (el, cat) {
          var cnt = el.querySelector('[data-count]');
          if (cnt) cnt.textContent = counts[cat];
          el.classList.toggle('is-empty', counts[cat] === 0);
          if (cat !== 'all') el.hidden = bases[cat] === 0 && !words.length && !self.design;
        };
        this.chips.forEach(function (c) {
          paint(c, c.dataset.cat);
          c.setAttribute('aria-pressed', c.dataset.cat === st.cat ? 'true' : 'false');
        });
        this.opts.forEach(function (o) {
          var cat = o.dataset.catOpt;
          if (counts[cat] === undefined) return;
          paint(o, cat);
          var input = o.querySelector('input');
          if (input) input.checked = cat === st.cat;
        });

        var nActive = st.topics.length + (st.sub ? 1 : 0);
        var tpl = list.length === 1 && this.dataset.statusOne ? this.dataset.statusOne : (this.dataset.status || '');
        var status = tpl.replace('[shown]', visible.length).replace('[total]', list.length);
        this.statusEl.textContent = status;
        if (this.applyBtn) this.applyBtn.textContent = (this.dataset.apply || '[results]').replace('[results]', status);
        if (this.filtersText) this.filtersText.textContent = (this.dataset.filters || '') + (nActive ? ' · ' + nActive : '');
        if (this.openBtn) {
          this.openBtn.classList.toggle('is-active', nActive > 0);
          this.openBtn.hidden = !subOrder.length && !topicOrder.length;
        }
        if (this.clearAllBtn) this.clearAllBtn.hidden = st.cat === 'all' && !nActive;
        all(this, '[data-hub-clear-topics]').forEach(function (b) { b.disabled = !nActive; });
        this.renderActive();

        var sortSel = this.sortSels[0];
        this.sortSels.forEach(function (sel) { sel.value = st.sort; });
        if (this.sortName && sortSel && sortSel.selectedIndex > -1) this.sortName.textContent = sortSel.options[sortSel.selectedIndex].text;

        var rest = list.length - visible.length;
        this.moreBtn.hidden = rest <= 0;
        this.moreBtn.textContent = (this.dataset.more || '+') + ' (' + Math.min(rest, this.per) + ')';
        this.emptyEl.hidden = list.length > 0;
        this.writeUrl();
        this.fadeTabs();
      }

      renderTopics(map, subOrder, topicOrder) {
        var self = this, st = this.state, order = subOrder.concat(topicOrder), shown = {};
        var has = order.length > 0;
        if (this.topicGroup) this.topicGroup.hidden = !has;
        if (this.pills) this.pills.hidden = !has;
        if (!this.topicList || !this.pillList) return;
        order.forEach(function (k, idx) {
          var m = map[k], e = self.topicEls[k] || (self.topicEls[k] = self.makeTopic(k, m.sub));
          var on = m.sub ? st.sub === k : st.topics.indexOf(k) > -1;
          e.c1.textContent = m.n;
          e.c2.textContent = m.n;
          e.input.checked = on;
          e.pill.setAttribute('aria-pressed', on ? 'true' : 'false');
          e.opt.classList.toggle('is-empty', !m.n);
          e.pill.classList.toggle('is-empty', !m.n);
          e.opt.classList.toggle('sgh-opt--split', m.sub && idx === subOrder.length - 1 && topicOrder.length > 0);
          e.opt.hidden = false;
          e.pill.hidden = false;
          shown[k] = true;
        });
        Object.keys(this.topicEls).forEach(function (k) {
          if (shown[k]) return;
          self.topicEls[k].opt.hidden = true;
          self.topicEls[k].pill.hidden = true;
        });
        var place = function (parent, els) {
          els.forEach(function (el, i) { if (parent.children[i] !== el) parent.insertBefore(el, parent.children[i] || null); });
        };
        place(this.topicList, order.map(function (k) { return self.topicEls[k].opt; }));
        place(this.pillList, order.map(function (k) { return self.topicEls[k].pill; }));
      }

      makeTopic(k, sub) {
        var label = this.label(k);
        var opt = document.createElement('label');
        opt.className = 'sgh-opt sgh-opt--check' + (sub ? ' sgh-opt--sub' : '');
        var input = document.createElement('input');
        input.type = 'checkbox';
        input.value = k;
        input.dataset.topic = k;
        var mark = document.createElement('span');
        mark.className = 'sgh-opt__mark';
        mark.setAttribute('aria-hidden', 'true');
        var name = document.createElement('span');
        name.className = 'sgh-opt__label';
        name.textContent = label;
        var c1 = document.createElement('span');
        c1.className = 'sgh-opt__count';
        opt.appendChild(input);
        opt.appendChild(mark);
        opt.appendChild(name);
        opt.appendChild(c1);
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'sgh-pill' + (sub ? ' sgh-pill--sub' : '');
        pill.dataset.topic = k;
        pill.textContent = label;
        var c2 = document.createElement('span');
        pill.appendChild(c2);
        this.topicList.appendChild(opt);
        this.pillList.appendChild(pill);
        return { opt: opt, input: input, c1: c1, pill: pill, c2: c2 };
      }

      renderActive() {
        var el = this.activeEl, st = this.state, self = this;
        if (!el) return;
        var rm = this.dataset.remove || '';
        var frag = document.createDocumentFragment();
        var mk = function (key, label) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'sgh-active__chip';
          b.dataset.remove = key;
          b.setAttribute('aria-label', (rm ? rm + ': ' : '') + label);
          b.textContent = label;
          b.insertAdjacentHTML('beforeend', X_ICON);
          frag.appendChild(b);
        };
        if (st.cat !== 'all' && this.catNames[st.cat]) mk('#cat', this.catNames[st.cat]);
        if (st.sub) mk(st.sub, this.label(st.sub));
        st.topics.forEach(function (k) { mk(k, self.label(k)); });
        el.innerHTML = '';
        el.appendChild(frag);
      }

      interleave(list) {
        var groups = {}, order = [];
        list.forEach(function (it) {
          if (!groups[it.cat]) { groups[it.cat] = []; order.push(it.cat); }
          groups[it.cat].push(it);
        });
        var out = [];
        for (var round = 0; out.length < list.length; round++) {
          order.forEach(function (c) { if (groups[c][round]) out.push(groups[c][round]); });
        }
        return out;
      }

      columns() {
        if (this.state.view !== 'grid') return 1;
        var gtc = getComputedStyle(this.grid).gridTemplateColumns;
        return gtc && gtc !== 'none' ? gtc.trim().split(/\s+/).length : 1;
      }

      placeNews() {
        var news = this.news, visible = this._visible || [];
        if (!news || this.nlAfter <= 0) return;
        if (!visible.length) { news.hidden = true; return; }
        var cols = this.columns(), slots = 0, anchor = visible[visible.length - 1].el;
        for (var k = 0; k < visible.length; k++) {
          var el = visible[k].el;
          var wide = cols > 1 && (el.classList.contains('is-featured') || el.classList.contains('sgh-card--spotlight'));
          var w = wide ? Math.min(2, cols) : 1;
          if (slots % cols + w > cols) slots += cols - slots % cols;
          slots += w;
          if (slots >= this.nlAfter && slots % cols === 0) { anchor = el; break; }
        }
        anchor.after(news);
        news.hidden = false;
      }

      formatDates() {
        var fmt;
        try { fmt = new Intl.DateTimeFormat(document.documentElement.lang || undefined, { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { return; }
        Array.prototype.forEach.call(this.querySelectorAll('[data-hub-date]'), function (t) {
          var d = new Date(t.getAttribute('datetime'));
          if (!isNaN(d)) t.textContent = fmt.format(d);
        });
      }

      initSticky() {
        var bar = this.querySelector('[data-hub-sticky]');
        if (!bar) return;
        var key = 'sgh-sticky-closed', self = this, newsSeen = false;
        try { if (localStorage.getItem(key)) return; } catch (e) {}
        this._sticky = bar;
        document.body.appendChild(bar);
        if (this.news && 'IntersectionObserver' in window) {
          new IntersectionObserver(function (en) { newsSeen = en[0].isIntersecting; tick(); }).observe(this.news);
        }
        var raf = 0;
        var tick = function () {
          if (document.querySelector('.sgh-kl__done:not(.hidden)')) {
            bar.classList.remove('is-visible');
            removeEventListener('scroll', self._onScroll);
            return;
          }
          var r = self.getBoundingClientRect();
          var on = r.top < -120 && r.bottom > innerHeight * 0.6 && !newsSeen;
          bar.classList.toggle('is-visible', on);
        };
        this._onScroll = function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; tick(); }); };
        addEventListener('scroll', this._onScroll, { passive: true });
        bar.querySelector('[data-hub-sticky-close]').addEventListener('click', function () {
          bar.classList.remove('is-visible');
          try { localStorage.setItem(key, '1'); } catch (e) {}
          setTimeout(function () { bar.remove(); }, 500);
        });
        var go = bar.querySelector('[data-hub-sticky-go]');
        go.addEventListener('click', function (e) {
          var h = go.getAttribute('href') || '';
          if (h.charAt(0) !== '#' || !self.news || self.news.hidden) return;
          e.preventDefault();
          self.news.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var input = self.news.querySelector('input[type="email"]');
          if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 450);
        });
      }
    }

    customElements.define('shelly-guide-hub', ShellyGuideHub);
  })();

  } catch(e) { console.error(e); }
})();
})();
